import React from 'react';
import { useSelector } from 'react-redux';
import { APP_COLOR_THEME_NAMES, COLOR_THEMES } from '@theme/appThemes';
import { useScreenSize } from './useWindowSize';
import { breakpoints } from '@constants/breakpoints';
import { colorPalette } from '@theme';
import { logger } from '@utils/usefulFuncs';
import { ROUTES } from '@constants/routes';
import { usePathnameSafe } from './useLocationSafe';
import { useCurrentUser } from '../user/useCurrentUser';

export const useGlobalTheme = () => {
  const colorThemeName = useColorTheme(true);
  const colorTheme = useColorTheme();
  const screenSize = useScreenSize();

  const theme = React.useMemo(() => {
    const generatedTheme = {
      colorTheme,
      colorThemeName,
      apiName: colorThemeName,
      ...colorPalette,
      colorPalette,
      breakpoints,
      themeColors: colorTheme,
      screenSize,
      themes: COLOR_THEMES,
    };
    logger(generatedTheme);
    return generatedTheme;
  }, [colorThemeName, colorTheme, colorPalette, screenSize]);
  return theme;
};

const forceLightThemeNonAuthRoutes = [ROUTES.splash];

const blue = '#1390e2';
const green = '#29E436';
const yellow = '#efed1b';
const grey = '#c6c6c6';

const brightGreen = colorPalette.secondary.brightGreen;
const orange = colorPalette.secondary.orange;

COLOR_THEMES[APP_COLOR_THEME_NAMES.lightProfessional].documentListNode = blue;
COLOR_THEMES[APP_COLOR_THEME_NAMES.darkProfessional].documentListNode = blue;

COLOR_THEMES[APP_COLOR_THEME_NAMES.lightProfessional].companyListNode = green;
COLOR_THEMES[APP_COLOR_THEME_NAMES.darkProfessional].companyListNode = green;

COLOR_THEMES[APP_COLOR_THEME_NAMES.lightProfessional].actionNode = yellow;
COLOR_THEMES[APP_COLOR_THEME_NAMES.darkProfessional].actionNode = yellow;

COLOR_THEMES[APP_COLOR_THEME_NAMES.lightProfessional].settingsNode = grey;
COLOR_THEMES[APP_COLOR_THEME_NAMES.darkProfessional].settingsNode = grey;

COLOR_THEMES[APP_COLOR_THEME_NAMES.lightProfessional].planStepNode = brightGreen;
COLOR_THEMES[APP_COLOR_THEME_NAMES.darkProfessional].planStepNode = brightGreen;

COLOR_THEMES[APP_COLOR_THEME_NAMES.lightProfessional].outputAggregationNode = orange;
COLOR_THEMES[APP_COLOR_THEME_NAMES.darkProfessional].outputAggregationNode = orange;

COLOR_THEMES[APP_COLOR_THEME_NAMES.lightProfessional].executionFlowNode = colorPalette.primary.charcoal;
COLOR_THEMES[APP_COLOR_THEME_NAMES.darkProfessional].executionFlowNode = colorPalette.primary.white;

export const useColorTheme = (nameOnly) => {
  const currentUser = useCurrentUser();
  const pathname = usePathnameSafe();

  const forceLightTheme = currentUser === null && forceLightThemeNonAuthRoutes.includes(pathname);
  const state_colorThemeName = useSelector((state) => state.colorTheme.value);
  const customTheme = useSelector((state) => state.colorTheme.customTheme);

  if (nameOnly) return forceLightTheme ? APP_COLOR_THEME_NAMES.lightProfessional : state_colorThemeName;
  if (forceLightTheme) return COLOR_THEMES[APP_COLOR_THEME_NAMES.lightProfessional];
  if (state_colorThemeName === APP_COLOR_THEME_NAMES.custom) return customTheme;
  return COLOR_THEMES[state_colorThemeName];
};
